<template>
  <div class="p-4">
    <JcImg :level="1"
      src="https://resources.jctrans.com/res/era-h5/h5/img/PageNotFound.png"
    />
    <div class="flex flex-col items-center justify-center mt-2">
      <span class="font-popSB font-semibold leading-6 whitespace-pre-line">{{
        isCn
          ? '抱歉，当前页面不存在，看看别的吧！'
          : 'Sorry, the current page does not exist.\n Please take a look at something else !'
      }}</span>
      <ClientOnly>
        <div v-if="isSit" class="mt-2">
          <div>{{ location }}</div>
          {{ route.fullPath }}
        </div>
      </ClientOnly>
      <!-- <span class="tips">Sorry, the page you request is not exist, please check the URL or view other pages. </span> -->
    </div>

    <div class="flex flex-col items-center justify-center mt-6">
      <a
        type="button"
        class="btn rounded"
        :href="getLineHref(`/`, isCn ? '/cn' : '/en')"
        @click.prevent="goEraPage('')"
      >
        <span class="back-home">{{ isCn ? 'JCtrans首页' : 'JCtrans' }}</span>
        <div class="w-[24px] h-[24px]">
          <IconArrowRight class="back-arrow text-[24px]" />
        </div>
      </a>
      <a
        type="button"
        class="btn rounded"
        :href="getLineHref(`/vip/`, isCn ? '/cn' : '/en')"
        @click.prevent="goEraPage('/vip/')"
      >
        <span class="back-home">{{ isCn ? '会员联盟' : 'Membership' }}</span>
        <div class="w-[24px] h-[24px]">
          <IconArrowRight class="back-arrow text-[24px]" />
        </div>
      </a>
      <a
        type="button"
        class="btn rounded"
        :href="getLineHref(`/company/`, isCn ? '/cn' : '/en')"
        @click.prevent="goEraPage('/company/')"
      >
        <span class="back-home">{{
          isCn ? '公司名录' : 'Company Directory'
        }}</span>
        <div class="w-[24px] h-[24px]">
          <IconArrowRight class="back-arrow text-[24px]" />
        </div>
      </a>
      <a
        type="button"
        class="btn rounded"
        :href="
          getLineHref(`/membership/tools/risk/blackList`, isCn ? '/cn' : '/en')
        "
        @click.prevent="goEraPage('/membership/tools/risk/blackList')"
      >
        <span class="back-home">{{
          isCn ? '风控指南' : 'Risk Control Guideline'
        }}</span>
        <div class="w-[24px] h-[24px]">
          <IconArrowRight class="back-arrow text-[24px]" />
        </div>
      </a>
      <a
        type="button"
        class="btn rounded"
        :href="getLineHref(`/news/`, isCn ? '/cn' : '/en')"
        @click.prevent="goEraPage('/news/')"
      >
        <span class="back-home">{{ isCn ? '新闻' : 'News' }}</span>
        <div class="w-[24px] h-[24px]">
          <IconArrowRight class="back-arrow text-[24px]" />
        </div>
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { reportCallBack } from '~/api/system'

  const route = useRoute()
  const pathname = route.path
  const isCn = computed(() => pathname.includes('/cn/'))
  const system = useMySystemStore()

  const isAPP = computed(() => system.isAPP)

  const location = computed(() => window?.location.toString())
  const isSit = computed(() => {
    return (
      location?.value.includes('sit') || location?.value.includes('localhost')
    )
  })

  const event = useRequestEvent()

  // event will be undefined in the browser
  if (event) {
    // Set the status message as well
    setResponseStatus(event, 404, 'Page Not Found')
  }

  const getDomain = () => {
    const config = useRuntimeConfig().public
    const { NAME, DOMAIN_NAME } = config
    return NAME === 'prod'
      ? `https://m.${DOMAIN_NAME}`
      : `https://m-${NAME}.${DOMAIN_NAME}`
  }

  const getLineHref = (path: any, lang = '') => {
    return path ? `${getDomain()}${lang}${path}` : ''
  }

  const goEraPage = (path: string) => {
    reportCallBack(
      {
        eventCode: 'MPERA.404PAGE.BUTTON.CLICK',
        extensions: {
          PATH: path || '',
        },
      },
      route.meta?.pageCode,
    )
    navigateTo({ path: `${isCn.value ? '/cn' : '/en'}${path}` })
  }

  useHead({
    title: isCn.value
      ? '页面未找到 -杰西圈JCtrans.com'
      : 'Page Not Found -JCtrans.com',
    meta: [
      {
        name: 'description',
        content: isCn.value
          ? '抱歉, 您当前访问的页面不存在,请尝试访问杰西圈JCtrans首页www.jctrans.com或查询货代公司名录列表https://www.jctrans.com/cn/company/'
          : 'Sorry, the page you’re looking for doesn’t exist. Try returning to our www.jctrans.com or check out our freight forwarders list https://www.jctrans.com/en/company/.”',
      },
      {
        name: 'keywords',
        content: isCn.value
          ? '404,页面不存在,JCtrans杰西圈'
          : '404,Page Not Found,JCtrans',
      },
    ],
  })
</script>

<style lang="scss" scoped>
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 330px;
    height: 55px;
    padding: 0 20px;
    margin-bottom: 32px;
    cursor: pointer;
    background: linear-gradient(90deg, #ff5000 0%, #ff8f12 100%);
    border: none;
    border-radius: 2px;
    opacity: 1;

    .back-home {
      font-family: Poppins-SemiBold, Poppins;
      font-size: 18px;
      font-weight: 600;
      line-height: 21px;
      color: #fff;
    }

    .back-arrow {
      width: 24px;
      height: 24px;
      color: #fff;
      fill: #fff;
    }
  }
</style>
